/* eslint-disable react/no-array-index-key */
/* eslint-disable operator-linebreak */
import { MobileNavigationItem } from '../mobile-navigation/mobile-navigation-item';
import { MobileNavigationMenu } from '../mobile-navigation/mobile-navigation-menu';
import { MobileNavigationMenuItem } from '../mobile-navigation/mobile-navigation-menu-item';
import { AppNavigationItem, NavigationItemType } from '../types';

export function MobileNavigationRender({ menuItem }: { menuItem: AppNavigationItem }) {
    if (menuItem === undefined) {
        return null;
    }

    if (menuItem.type !== NavigationItemType.DropdownMenu) {
        return (
            <MobileNavigationItem
                to={menuItem.to}
                label={menuItem.title}
                isExternal={menuItem.type === NavigationItemType.ExternalLink}
            />
        );
    }

    if (menuItem.type === NavigationItemType.DropdownMenu && menuItem.dropdownItems) {
        return (
            <MobileNavigationMenu label={menuItem.title}>
                {menuItem.dropdownItems.map((subMenuItem, index) => (
                    <MobileNavigationMenuItem
                        key={index}
                        to={subMenuItem.to}
                        label={subMenuItem.title}
                        isExternal={subMenuItem.type === NavigationItemType.ExternalLink}
                    />
                ))}
            </MobileNavigationMenu>
        );
    }

    return null;
}
